import { useState } from 'react';
import ConfirmationPrompt from './ConfirmationPrompt';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';

type SaveButtonWithConfirmationPromptProps = {
  onSave: () => void;
  disabled: boolean;
};

const SaveButtonWithConfirmationPrompt = ({
  onSave,
  disabled,
}: SaveButtonWithConfirmationPromptProps) => {
  const [confirmationPromptOpen, setConfirmationPromptOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={() => setConfirmationPromptOpen(true)}
        disabled={disabled}
        disableElevation
      >
        <FormattedMessage id="platform_settings.save" />
      </Button>
      <ConfirmationPrompt
        open={confirmationPromptOpen}
        onCancel={() => setConfirmationPromptOpen(false)}
        onConfirm={() => {
          setConfirmationPromptOpen(false);
          onSave();
        }}
      />
    </>
  );
};

export default SaveButtonWithConfirmationPrompt;
